function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Array$isArray from "@babel/runtime-corejs3/core-js/array/is-array";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _setTimeout from "@babel/runtime-corejs3/core-js/set-timeout";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import React, { useState, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import { facetShape } from "../../utils/facet_prop_type.js";
import FilterActionSection from "../FilterActionSection/index.js";
import FacetsGroup from "../FacetsGroup/index.js";
import UpDownToggleButton from "../UpDownToggleButton/index.js";
import Styles from "./styles.css";
import { objectsEqual } from "../../utils/object_extension.js";
import { defineFilterUrl, defineUrl } from "../../utils/get_url.js";
import { isMobile } from "../../utils/browser.js";
var FacetFilterContainer = function FacetFilterContainer(_ref) {
  var facets = _ref.facets,
    _ref$selected_facets = _ref.selected_facets,
    selected_facets = _ref$selected_facets === void 0 ? {} : _ref$selected_facets,
    filterRankSlugs = _ref.filter_rank_slugs,
    pathFragment = _ref.path_fragment,
    altResourceSlug = _ref.alt_resource_slug,
    facetFilterCounterUrl = _ref.facets_filter_counter_url,
    results_count = _ref.results_count,
    productType = _ref.product_type,
    categoryPagePath = _ref.category_page_path,
    specificSlugForFacetMapping = _ref.specific_slug_for_facet_mapping,
    filterButtonRef = _ref.filterButtonRef;
  var _useState = useState(_Object$keys(selected_facets || {}).length),
    _useState2 = _slicedToArray(_useState, 2),
    filterCount = _useState2[0],
    setFilterCount = _useState2[1];
  var _useState3 = useState(results_count),
    _useState4 = _slicedToArray(_useState3, 2),
    resultsCount = _useState4[0],
    setResultsCount = _useState4[1];
  var _useState5 = useState(selected_facets || {}),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedFacets = _useState6[0],
    setSelectedFacets = _useState6[1];
  var _useState7 = useState(_Object$keys(selected_facets || {}).length === 0),
    _useState8 = _slicedToArray(_useState7, 2),
    clearButtonDisabled = _useState8[0],
    setClearButtonDisabled = _useState8[1];
  var _useState9 = useState(true),
    _useState10 = _slicedToArray(_useState9, 2),
    applyButtonDisabled = _useState10[0],
    setApplyButtonDisabled = _useState10[1];
  var _useState11 = useState('javascript:void(0)'),
    _useState12 = _slicedToArray(_useState11, 2),
    applyUrl = _useState12[0],
    setApplyUrl = _useState12[1];
  var _useState13 = useState({
      text: 'Filter',
      isOpen: false
    }),
    _useState14 = _slicedToArray(_useState13, 2),
    mobileFilter = _useState14[0],
    setMobileFilter = _useState14[1];
  var facetsGroupRef = useRef(null);
  var fashionFilterHeaderRef = useRef(null);
  var defineApplyUrl = useMemo(function () {
    return defineUrl({
      filterRankSlugs: filterRankSlugs,
      altResourceSlug: altResourceSlug,
      specificSlugForFacetMapping: specificSlugForFacetMapping,
      pathFragment: pathFragment
    });
  }, [filterRankSlugs, altResourceSlug, specificSlugForFacetMapping, pathFragment]);
  var filterCounterUrl = useMemo(function () {
    return defineFilterUrl({
      facets: facets,
      facetFilterCounterUrl: facetFilterCounterUrl
    });
  }, [facets, facetFilterCounterUrl]);
  var clearFilters = function clearFilters() {
    setSelectedFacets({});
    setFilterCount(0);
    setApplyButtonDisabled(true);
    setClearButtonDisabled(true);
    setApplyUrl('javascript:void(0)');
  };
  var handleFilterChange = function handleFilterChange(data) {
    var newSelectedFacets = _objectSpread({}, selectedFacets);
    if (!newSelectedFacets[data.seo_slug]) newSelectedFacets[data.seo_slug] = [];
    if (data.value === 'none') {
      delete newSelectedFacets[data.seo_slug];
    } else if (data.is_radio_button) {
      newSelectedFacets[data.seo_slug] = [data.value];
    } else {
      var _context;
      if (!_Array$isArray(newSelectedFacets[data.seo_slug])) newSelectedFacets[data.seo_slug] = [newSelectedFacets[data.seo_slug]];
      if (_includesInstanceProperty(_context = newSelectedFacets[data.seo_slug]).call(_context, data.value)) {
        var _context2;
        newSelectedFacets[data.seo_slug] = _filterInstanceProperty(_context2 = newSelectedFacets[data.seo_slug]).call(_context2, function (value) {
          return value !== data.value;
        });
        if (newSelectedFacets[data.seo_slug].length === 0) {
          delete newSelectedFacets[data.seo_slug];
        }
      } else {
        newSelectedFacets[data.seo_slug].push(data.value);
      }
    }
    var newFilterCount = _Object$keys(newSelectedFacets).length;
    var newApplyButtonDisabled = !isFilterChange(newSelectedFacets, selectedFacets);
    var newApplyUrl = !newApplyButtonDisabled ? defineApplyUrl(newSelectedFacets) : 'javascript:void(0)';
    setSelectedFacets(newSelectedFacets);
    setFilterCount(newFilterCount);
    setApplyButtonDisabled(newApplyButtonDisabled);
    setApplyUrl(newApplyUrl);
    getResultsCount(newSelectedFacets);
  };
  var handleMobileFilter = function handleMobileFilter() {
    var isOpen = !mobileFilter.isOpen;
    var newMobileFilter = {
      isOpen: isOpen,
      text: isOpen ? 'Hide Filters' : 'Filter'
    };
    var slideDown = function slideDown(element, duration) {
      element.style.height = '0px';
      element.style.display = 'block';
      var height = element.scrollHeight;
      var start = null;
      var animate = function animate(timestamp) {
        if (!start) start = timestamp;
        var progress = timestamp - start;
        var heightProgress = Math.min(progress / duration, 1) * height;
        element.style.height = "".concat(heightProgress, "px");
        if (progress < duration) {
          requestAnimationFrame(animate);
        } else {
          element.style.height = '';
        }
      };
      requestAnimationFrame(animate);
    };
    var slideUp = function slideUp(element, duration) {
      var height = element.scrollHeight;
      var start = null;
      var animate = function animate(timestamp) {
        if (!start) start = timestamp;
        var progress = timestamp - start;
        var heightProgress = height - Math.min(progress / duration, 1) * height;
        element.style.height = "".concat(heightProgress, "px");
        if (progress < duration) {
          requestAnimationFrame(animate);
        } else {
          element.style.display = 'none';
          element.style.height = '';
        }
      };
      requestAnimationFrame(animate);
    };
    if (isOpen) {
      slideDown(facetsGroupRef.current, 300);
      _setTimeout(function () {
        slideDown(fashionFilterHeaderRef.current, 200);
        progressBarDisable(true);
      }, 200);
    } else {
      slideUp(facetsGroupRef.current, 300);
      slideUp(fashionFilterHeaderRef.current, 200);
      progressBarDisable();
    }
    var event = new CustomEvent("mobileFilterOpen", {
      detail: {
        isOpen: mobileFilter.isOpen
      }
    });
    window.dispatchEvent(event);
    setMobileFilter(newMobileFilter);
  };
  var isFilterChange = function isFilterChange(selectedFacets, oldSelectedFacets) {
    return !objectsEqual(selectedFacets, oldSelectedFacets);
  };
  var applyTrackParams = function applyTrackParams() {
    var params = {
      resultsCount: resultsCount,
      platform: 'web',
      product: 'fashion',
      filterCount: filterCount,
      source: isMobile() ? 'bottom apply button' : "top apply button"
    };
    return coverFacetTrackParams(params);
  };
  var coverFacetTrackParams = function coverFacetTrackParams(baseParams) {
    var _context3;
    _forEachInstanceProperty(_context3 = _Object$keys(selectedFacets)).call(_context3, function (seo_slug) {
      var _context4;
      var selectedFacet = _findInstanceProperty(facets).call(facets, function (facet) {
        return facet.seo_slug === seo_slug;
      });
      var selectedValues = _filterInstanceProperty(_context4 = _valuesInstanceProperty(selectedFacet)).call(_context4, function (value) {
        var _context5;
        return _includesInstanceProperty(_context5 = selectedFacets[seo_slug]).call(_context5, value.seo_slug);
      });
      if (seo_slug === 'designer') {
        baseParams['designer_id'] = selectedValues[0].designer_id;
      } else if (seo_slug === 'tuxedo-tail') {
        baseParams['suit-and-tuxedo'] = _mapInstanceProperty(selectedValues).call(selectedValues, function (value) {
          return value.label;
        });
      } else if (seo_slug === 'neckline') {
        baseParams[seo_slug] = _mapInstanceProperty(selectedValues).call(selectedValues, function (value) {
          return value.label === 'High' ? 'High Neck' : value.label;
        });
      } else {
        baseParams[seo_slug] = _mapInstanceProperty(selectedValues).call(selectedValues, function (value) {
          return value.label;
        });
      }
    });
    return baseParams;
  };
  var getResultsCount = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(selectedFacets) {
      var url, retryLimit, tryCount, fetchData, resultsCount;
      return _regeneratorRuntime().wrap(function _callee2$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            url = filterCounterUrl(selectedFacets);
            retryLimit = 3;
            tryCount = 0;
            fetchData = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                var response, json;
                return _regeneratorRuntime().wrap(function _callee$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.prev = 0;
                      _context6.next = 3;
                      return fetch(url, {
                        method: 'GET'
                      });
                    case 3:
                      response = _context6.sent;
                      if (response.ok) {
                        _context6.next = 6;
                        break;
                      }
                      throw new Error('Network response was not ok');
                    case 6:
                      _context6.next = 8;
                      return response.json();
                    case 8:
                      json = _context6.sent;
                      return _context6.abrupt("return", json.totalCount);
                    case 12:
                      _context6.prev = 12;
                      _context6.t0 = _context6["catch"](0);
                      if (tryCount < retryLimit) {
                        tryCount++;
                        _setTimeout(fetchData, 1000);
                      }
                    case 15:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee, null, [[0, 12]]);
              }));
              return function fetchData() {
                return _ref3.apply(this, arguments);
              };
            }();
            _context7.next = 6;
            return fetchData();
          case 6:
            resultsCount = _context7.sent;
            setResultsCount(resultsCount);
          case 8:
          case "end":
            return _context7.stop();
        }
      }, _callee2);
    }));
    return function getResultsCount(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var progressBarDisable = function progressBarDisable(isDisabled) {
    var progressBar = document.querySelector('.instructions .complete');
    if (!progressBar) return;
    if (isDisabled) {
      progressBar.setAttribute('tabindex', '-1');
      progressBar.setAttribute('aria-disabled', 'true');
    } else {
      progressBar.removeAttribute('tabindex');
      progressBar.removeAttribute('aria-disabled');
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "fashion-filter-container",
    className: Styles['filter-container']
  }, /*#__PURE__*/React.createElement("div", {
    className: Styles['fashion-filter-header'],
    ref: fashionFilterHeaderRef
  }, /*#__PURE__*/React.createElement("h3", {
    className: Styles['filter-count']
  }, "Filters (".concat(filterCount, ")")), /*#__PURE__*/React.createElement("div", {
    className: Styles['mobile-filter-hide']
  }, mobileFilter.isOpen ? /*#__PURE__*/React.createElement(UpDownToggleButton, {
    onClick: handleMobileFilter,
    buttonRef: filterButtonRef,
    text: mobileFilter.text,
    isOpen: mobileFilter.isOpen
  }) : ''), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(FilterActionSection, {
    apply_button_disabled: applyButtonDisabled,
    clear_button_disabled: clearButtonDisabled,
    apply_url: applyUrl,
    clear_url: categoryPagePath || 'javascript:void(0)',
    applyTrackParams: applyTrackParams(),
    productType: productType,
    resultsCount: resultsCount
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(Styles['facets-filter-divider'], " filter-divider-border")
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(Styles['facets-group']),
    ref: facetsGroupRef
  }, _mapInstanceProperty(facets).call(facets, function (facet) {
    return /*#__PURE__*/React.createElement(FacetsGroup, {
      key: facet.seo_slug,
      is_wedding_dresses: pathFragment === 'wedding-dresses',
      facet_label: facet.label,
      is_default_filter: facet.is_default_filter,
      values: _valuesInstanceProperty(facet),
      onChange: handleFilterChange,
      seo_slug: facet.seo_slug,
      select_type: facet.select_type,
      selected: selectedFacets[facet.seo_slug]
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: Styles['mobile-filter']
  }, !mobileFilter.isOpen ? /*#__PURE__*/React.createElement(UpDownToggleButton, {
    onClick: handleMobileFilter,
    buttonRef: filterButtonRef,
    text: mobileFilter.text,
    isOpen: mobileFilter.isOpen
  }) : '', filterCount && !mobileFilter.isOpen ? /*#__PURE__*/React.createElement("a", {
    className: Styles['mobile-filter-clear'],
    href: categoryPagePath || 'javascript:void(0)',
    onClick: !categoryPagePath ? clearFilters : null
  }, /*#__PURE__*/React.createElement("span", null, "Clear (", filterCount, ")")) : ''), /*#__PURE__*/React.createElement("div", {
    className: "scrollable-ad"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: "div-gpt-ad-1485460147044-0"
  }))));
};
process.env.NODE_ENV !== "production" ? FacetFilterContainer.propTypes = {
  facets: PropTypes.arrayOf(facetShape()).isRequired,
  selected_facets: PropTypes.object,
  filter_rank_slugs: PropTypes.array,
  path_fragment: PropTypes.string.isRequired,
  alt_resource_slug: PropTypes.string,
  results_count: PropTypes.number,
  product_type: PropTypes.string.isRequired,
  category_page_path: PropTypes.string
} : void 0;
export default FacetFilterContainer;